/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalEntityInputsComponent } from './legal-entity-inputs/legal-entity-inputs.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LegalEntityAutocompleteComponent } from './legal-entity-autocomplete/legal-entity-autocomplete.component';
import { ResourceDropdownModule } from '@well/resource-dropdown';
import { PrimengUtilsModule } from '@irian-ro/primeng-utils-module';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogModule } from '@well/confirmation-dialog';
import { Select, SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedComponentsModule as IriroSharedComponentsModule } from '@irian-ro/shared-components-module';
import { LegalEntityViewComponent } from './legal-entity-view/legal-entity-view.component';
import { LegalEntityExternalDetailsComponent } from './legal-entity-external-details/legal-entity-external-details.component';
import { SelectItemsModule } from '@well/select-items-shell-api';
import { CompanyCountryDropdownComponent } from './company-country-dropdown/company-country-dropdown.component';
import { TooltipModule } from 'primeng/tooltip';
import { SharedComponentsModule } from '@well/shared-components';
import {
  AbstractLegalEntitySearchService,
  CompanyLegalEntitySearchService,
} from '@well/common-libs/legal-entity-management/data-access';
import { AddressPickerComponent } from '@well/ui-address-management';
import { FieldsetModule } from 'primeng/fieldset';
import { DividerModule } from 'primeng/divider';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { InputTrimDirective } from '@well/infra/directives';
import { LegalEntityCardComponent } from './legal-entity-card/legal-entity-card.component';
import { FloatLabel } from 'primeng/floatlabel';
import { DatePicker } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import {
  BsAutocompleteComponent,
  BsItemDirective,
  BsFloatLabelCompatDirective
} from 'iriro-frontend-libs/bs-component-store';

@NgModule({
  imports: [
    TextareaModule,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    InputTextModule,
    PrimengUtilsModule,
    ButtonModule,
    ResourceDropdownModule,
    SelectModule,
    CheckboxModule,
    DatePicker,
    ConfirmationDialogModule,
    SharedComponentsModule,
    IriroSharedComponentsModule,
    SelectItemsModule,
    TooltipModule,
    AddressPickerComponent,
    FieldsetModule,
    DividerModule,
    FormInlineErrorDirective,
    InputTrimDirective,
    LegalEntityCardComponent,
    FloatLabel,
    AutoComplete,
    Select,
    DatePicker,
    BsAutocompleteComponent,
    BsItemDirective,
    BsFloatLabelCompatDirective,
  ],
  declarations: [
    LegalEntityInputsComponent,
    LegalEntityAutocompleteComponent,
    LegalEntityViewComponent,
    LegalEntityExternalDetailsComponent,
    CompanyCountryDropdownComponent,
  ],
  exports: [
    LegalEntityInputsComponent,
    LegalEntityAutocompleteComponent,
    LegalEntityViewComponent,
    LegalEntityExternalDetailsComponent,
  ],
  providers: [{ provide: AbstractLegalEntitySearchService, useClass: CompanyLegalEntitySearchService }],
})
export class LegalEntityManagementModule {}
